module.exports={
    "jersey": {
        "code": "jersey",
        "name": "Jersey"
    },
    "pant": {
        "code": "pant",
        "name": "Pant"
    }
}